import { type FragmentOf, graphql, readFragment } from "@/graphql"
import { OffPeakValuesSchema } from "../../schemas/offPeakValuesSchema"
import { MeterPointOffPeakSeason } from "../MeterPointOffPeakSeason"
import { OffPeakSeasonTooltip } from "../OffPeakSeasonTooltip"

const graphQLFragments = {
    seasonalOffPeak: graphql(`
        fragment MeterPointOffPeakValues_SeasonalOffPeak on SeasonalOffPeak {
            label
            season {
                code
                endDay
                endMonth
                startDay
                startMonth
            }
        }
    `),
}

type MeterPointOffPeakValuesProps = {
    Component: React.ElementType
    offPeakValues: (FragmentOf<typeof graphQLFragments.seasonalOffPeak> | null)[]
}

export function MeterPointOffPeakValues(props: MeterPointOffPeakValuesProps) {
    const { Component } = props

    const offPeakValues = props.offPeakValues.map((offPeakValue) =>
        readFragment(graphQLFragments.seasonalOffPeak, offPeakValue)
    )

    const parsedOffPeakValues = OffPeakValuesSchema.min(1).safeParse(offPeakValues)

    if (!parsedOffPeakValues.success) {
        return null
    }

    return parsedOffPeakValues.data.map((offPeakValue) => (
        <Component key={offPeakValue.season.code}>
            <MeterPointOffPeakSeason offPeakValue={offPeakValue} />{" "}
            <OffPeakSeasonTooltip offPeakValue={offPeakValue} />
        </Component>
    ))
}

MeterPointOffPeakValues.messages = [
    ...MeterPointOffPeakSeason.messages,
    ...OffPeakSeasonTooltip.messages,
] as const

MeterPointOffPeakValues.fragments = graphQLFragments
